import React from 'react';
import {useAuth} from './useAuth'
import {
    useLocation,
    Navigate,
    Outlet,
} from "react-router-dom";


export function RequireAuth() {
    let auth = useAuth();
    let location = useLocation();
    if (!auth.user) {
        return <Navigate to="/login" state={{from: location}}/>;
    }

    return <Outlet/>;
}